import styled from "styled-components";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import * as Type from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";

export const Header = styled.div`
    margin-top: ${theme.space[3]}px;
    margin-bottom: ${theme.space[3]}px;

    ${Type.MicroText} {
        color: ${theme.colors.platinumDark};
    }
`;

export const ResultCount = styled(Type.MicroText)`
    text-align: end;
    color: ${theme.colors.platinumDark};
    hyphens: auto;
`;
